import { ApiRequestConfig, apiService } from '../../../services/api.service';

import { ISingleResponse } from '@/interfaces/api/IApiBaseResponse';
import { IApiService } from '@/interfaces/services/IApiService';
import { IAuthService } from '@/pages/auth/interfaces/IAuthService';
import { IRefreshSessionResponse } from '@/pages/auth/interfaces/IRefreshSessionResponse';
import { ISignInResponse } from '@/pages/auth/interfaces/ISignInResponse';
import { ISignUpResponse } from '@/pages/auth/interfaces/ISignUpResponse';
import { ISuccessfulAuthenticationResponse } from '@/pages/auth/interfaces/ISuccessfulAuthenticationResponse';

class AuthService implements IAuthService {
	api: IApiService<ApiRequestConfig>;
	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}
	async signIn(username: string, password: string, config?: ApiRequestConfig) {
		return await this.api.post<ISingleResponse<ISignInResponse>>(
			'/auth/sign-in',
			{ username, password },
			config,
		);
	}
	async signUp(username: string, password: string, config?: ApiRequestConfig) {
		return await this.api.post<ISingleResponse<ISignUpResponse>>(
			'/auth/sign-up',
			{ username, password },
			config,
		);
	}
	async confirmUser(username: string, code: string, config?: ApiRequestConfig) {
		return await this.api.post<
			ISingleResponse<ISuccessfulAuthenticationResponse>
		>('/auth/confirm-user', { username, code }, config);
	}
	async confirmPassword(
		username: string,
		newPassword: string,
		code: string,
		config?: ApiRequestConfig,
	) {
		return await this.api.post<
			ISingleResponse<ISuccessfulAuthenticationResponse>
		>('/auth/confirm-password', { username, newPassword, code }, config);
	}
	async resendConfirmationCode(username: string, config?: ApiRequestConfig) {
		return await this.api.post<
			ISingleResponse<ISuccessfulAuthenticationResponse>
		>('/auth/resend-confirmation-code', { username }, config);
	}
	async forgotPassword(username: string, config?: ApiRequestConfig) {
		return await this.api.post<
			ISingleResponse<ISuccessfulAuthenticationResponse>
		>('/auth/forgot-password', { username }, config);
	}
	async refreshToken(refreshToken: string, config?: ApiRequestConfig) {
		return await this.api.post<ISingleResponse<IRefreshSessionResponse>>(
			'/auth/refresh',
			{ refreshToken },
			config,
		);
	}
}

export const authService = new AuthService(apiService);
